import * as React from 'react';
import styled from 'styled-components';
import FieldDecorator from './FieldDecorator';
import { ChangeableValue } from './Input';
import { hasValue } from '../../lib/utils';
import { baseInputCss } from './StyledElements';

const TextAreaField = (props: Props) => {
	const { onValueChange, label, errorMessage, validate, ...rest } = props;
	const [errorMessageState, setErrorMessageState] = React.useState('');

	const performAllValidation = (value: string) => {
		if (props.required && !hasValue(value)) {
			let { label: updatedLabel } = props;
			if (updatedLabel.slice(0, 4).includes(`${props.id}.`)) updatedLabel = updatedLabel.replace(`${props.id}.`, '');
			// TODO This code block is repeated from Input.tsx, consider revising. Custom hook?
			if (updatedLabel.length > 30 || updatedLabel.includes('?') || updatedLabel.includes('[')) updatedLabel = 'This';
			return `${updatedLabel || props.name} is required.`;
		}
		if (validate) {
			return validate(value);
		}
		return null;
	};

	const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		const { value } = event.target;
		const updatedErrorMessage = performAllValidation(value);
		// This is so that the onMount validation won't display an error message.
		if (props.value !== value) {
			setErrorMessageState(updatedErrorMessage);
		}
		onValueChange(props.name, value, updatedErrorMessage);
	};

	const handleBlur = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		const value = event.target.value.trim();
		const updatedErrorMessage = performAllValidation(value);
		// This is so that the onMount validation won't display an error message.
		if (props.value !== value) {
			setErrorMessageState(updatedErrorMessage);
		}
		onValueChange(props.name, value, updatedErrorMessage);
	};

	return (
		<FieldDecorator
			className={props.className}
			label={label}
			htmlFor={props.name}
			errorMessage={errorMessage || errorMessageState}
		>
			<TextArea
				className="k-textbox"
				// eslint-disable-next-line react/jsx-props-no-spreading
				{...rest}
				value={props.value ? props.value : ''}
				onChange={handleChange}
				onBlur={handleBlur}
				readOnly={props.readOnly}
			/>
		</FieldDecorator>
	);
};

interface Props extends ChangeableValue, React.InputHTMLAttributes<HTMLTextAreaElement> {
	label?: string;
	errorMessage?: string;
	validate?: (value: string) => string;
	readOnly?: boolean;
}

TextAreaField.defaultProps = {
	label: null,
	errorMessage: null,
	validate: null,
	readOnly: null
};

export default TextAreaField;

const TextArea = styled.textarea`
	${baseInputCss}
	padding: 8px 4px;
`;
